/* efa-cart.js — Améliorations CRO/a11y du tiroir panier (Éclairage Français)
 * Additif : n'altère AUCUN comportement natif du thème.
 * - Accessibilité : focus dans le tiroir à l'ouverture, focus-trap (Tab), retour du focus
 *   au déclencheur à la fermeture, fond rendu inerte, live regions (Échap = déjà géré par le thème).
 * - Cross-sell : recommandations Shopify injectées dynamiquement par une CASCADE en couches
 *   (seed = article le plus cher ; Layer 1 complementary, Layer 2 related, Layer 3 repli même
 *   collection, Layer 4 appoint remises = collection Soldes via section_id=efa-cart-promo).
 *   Cible interne >= 10 cartes, toutes ADDABLES 1-clic (filtre source data-efa-add), exclusion
 *   panier + seed, dédoublonnage, composition quota >= 50 % de remises RÉELLES (compare_at_price>price).
 *   Rendu INCRÉMENTAL (les ~4 premières peintes dès le Layer 1, le reste appendé), async non bloquant
 *   (AbortController + token de génération), cascade déclenchée à l'OUVERTURE du tiroir. Ajout 1-clic.
 *   data-sale-ratio posé sur le conteneur (observabilité du quota réellement atteint).
 * NB : le thème remplace #cart.innerHTML à chaque MAJ ; live regions sur body, clics délégués sur document.
 *
 * COUPLAGE THÈME (thème « Next », à re-tester avant chaque publication) :
 *   Ce script dépend de hooks non contractuels du thème. Si l'un d'eux change, vérifier ici.
 *   - .m6pn-open (classe sur <html> qui signale l'ouverture du tiroir)
 *   - .m6pn-close (bouton de fermeture natif du thème, peut vivre hors de #cart)
 *   - .side-cart-wrapper (conteneur ré-rendu à chaque MAJ panier)
 *   - .semantic-amount (montants formatés)
 *   - .f8vl (libellés divers)
 *   - .l4ca (liste des articles), .l4tt (totaux)
 *   - a.overlay-buy_button (CTA secondaire « Voir le panier »)
 *   - window.ajaxCart.load (rafraîchissement du tiroir après ajout)
 *   - header[data-totalqty] (compteur d'articles, ancre persistante pour le focus)
 *   data-efa-cart est posé sur l'aside pour ne pas dépendre que de l'id #cart.
 */
(function () {
  if (window.__efaCart) return;
  window.__efaCart = true;

  function init() {
    var cart = document.getElementById('cart');
    if (!cart) return;
    cart.setAttribute('data-efa-cart', '');
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';

    var SR_CSS = 'position:absolute;width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap;border:0';

    /* ---------- Live region « status » (polite) : confirmations ---------- */
    var live = document.createElement('div');
    live.setAttribute('role', 'status');
    live.setAttribute('aria-live', 'polite');
    live.className = 'efa-cart-live';
    live.style.cssText = SR_CSS;
    document.body.appendChild(live);

    /* ---------- Live region « alert » (assertive) : erreurs uniquement ---------- */
    var liveAlert = document.createElement('div');
    liveAlert.setAttribute('role', 'alert');
    liveAlert.className = 'efa-cart-live-alert';
    liveAlert.style.cssText = SR_CSS;
    document.body.appendChild(liveAlert);

    /* ---------- État partagé (scope init) ---------- */
    var recoGen = 0;            // token de génération du cross-sell (anti-écriture périmée)
    var efaMutating = false;    // flag self-mutating : true pendant nos propres écritures DOM
    var lastWrapper = null;     // identité du .side-cart-wrapper observé (anti-boucle)
    var cartUpdatedFlag = false; // une MAJ panier (data-totalqty) vient d'être annoncée
    var efaSilentCount = false;  // retrait differe : l'annonce du resultat remplace « Panier mis a jour »

    /* Barre du franco, franchissement du palier (WEBDEV GLOBAL 20, 24/09/2026, decision de Timothee).
       Le theme remplace le tiroir a chaque MAJ : on retient le remplissage du dernier rendu vu (en %, null sans
       barre). Si le rendu suivant porte l'etat atteint (.efa-franco-atteint, section-side-cart.liquid) alors que le
       precedent etait sous le palier, on pose .efa-franco-anim avant la peinture : la barre part de sa largeur
       precedente et se remplit, puis « Livraison offerte » apparait en fondu (CSS dans la section).
       Rien au chargement de la page, rien en mouvement reduit. Revert : retirer ce bloc et son appel dans
       syncCartVisualState. */
    var efaFrancoLast = null;
    function syncFranco() {
      var bar = cart.querySelector('.s1ld[data-of]');   // le theme deballe .side-cart-wrapper apres rendu (mesure le 24/09)
      var now = null;
      if (bar) {
        var of = parseFloat(bar.getAttribute('data-of'));
        var val = parseFloat(bar.getAttribute('data-val'));
        if (bar.classList.contains('efa-franco-atteint')) now = 100;
        else if (of > 0 && isFinite(val)) now = Math.max(0, Math.min(99.9, val / of * 100));
      }
      if (now === 100 && efaFrancoLast !== null && efaFrancoLast < 100 && !bar.classList.contains('efa-franco-anim') &&
          !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)) {
        bar.style.setProperty('--efa-franco-from', efaFrancoLast.toFixed(1) + '%');
        if (!drawerOpen()) bar.style.setProperty('--efa-franco-delay', '350ms');
        bar.classList.add('efa-franco-anim');
      }
      efaFrancoLast = now;
    }

    /* ---------- Etat vide / annulation du dernier article ---------- *
     * Le theme reinjecte volontairement l'ancienne ligne `.removing` dans le
     * markup du panier vide pendant la fenetre d'annulation. Il masque alors
     * uniquement `.empty`, laissant le CTA vide et la ligne d'annulation dans
     * deux zones tres eloignees. On expose un etat unique sur #cart avant
     * la prochaine peinture ; le CSS peut ainsi composer un vrai interstitiel
     * d'annulation, puis reveler l'etat vide normal a l'expiration. */
    function syncCartVisualState() {
      var header = cart.querySelector('header[data-totalqty]');
      var list = cart.querySelector('.l4ca');
      var removing = list && list.querySelector(':scope > li.removing');
      var emptyBlock = cart.querySelector('.efa-cart-empty');
      var count = header ? parseInt(header.getAttribute('data-totalqty'), 10) : NaN;
      var isEmpty = count === 0 || !!emptyBlock;
      var isEmptyUndo = isEmpty && !!removing;

      // #cart survit au remplacement AJAX de Shopify, contrairement au wrapper.
      cart.classList.toggle('efa-cart-is-empty', isEmpty);
      cart.classList.toggle('efa-cart-empty-undo', isEmptyUndo);

      if (list) {
        var delay = parseFloat(list.getAttribute('data-delay'));
        list.style.setProperty('--efa-undo-duration', (isFinite(delay) && delay > 0 ? delay : 3000) + 'ms');
      }
      if (isEmptyUndo) {
        var notice = removing.querySelector('.removed');
        if (notice) {
          notice.setAttribute('role', 'status');
          notice.setAttribute('aria-live', 'polite');
          notice.setAttribute('aria-atomic', 'true');
        }
      }
      /* lien de fermeture cree par le theme (« Close ») : nom accessible dans la langue du site */
      var closeLink = cart.querySelector('.m6pn-close');
      if (closeLink && TXT && closeLink.getAttribute('aria-label') !== TXT.close) closeLink.setAttribute('aria-label', TXT.close);
      syncPending();   // retrait differe : reposer l'etat « en attente » apres tout re-rendu
      watchMore();     // pied collant : fondu seulement quand du contenu passe dessous
      syncFranco();    // barre du franco : animation au franchissement du palier
      syncQuantityControls();
    }

    function curCount() {
      var h = cart.querySelector('header[data-totalqty]');
      return h ? h.getAttribute('data-totalqty') : null;
    }
    var lastCount = curCount();
    /* Observer A — annonce a11y SEULE (conditionnée au changement de data-totalqty
     * pour ne pas spammer le lecteur d'écran). Le re-layout est géré par l'observer B. */
    new MutationObserver(function () {
      var c = curCount();
      if (c !== null && c !== lastCount) {
        lastCount = c;
        cartUpdatedFlag = true;
        if (efaSilentCount) return;   // retrait differe : le resultat est annonce par settle()
        live.textContent = 'Panier mis à jour, ' + c + (c === '1' ? ' article' : ' articles');
      }
    }).observe(cart, { subtree: true, childList: true, attributes: true, attributeFilter: ['data-totalqty'] });

    /* ---------- Inertie du fond (pattern modal WCAG/APG) ---------- *
     * À l'ouverture : poser inert + aria-hidden sur chaque enfant de body qui NE contient
     * PAS le tiroir. Jamais inerter un ancêtre du tiroir (#cart est niché dans #root).
     * Exclusions : l'élément qui est/contient le tiroir, les live regions, et SCRIPT/LINK/STYLE. */
    function setBackgroundInert() {
      var kids = document.body.children;
      for (var i = 0; i < kids.length; i++) {
        var el = kids[i];
        var tag = el.tagName;
        if (el === cart || el.contains(cart)) continue;
        if (tag === 'SCRIPT' || tag === 'LINK' || tag === 'STYLE') continue;
        if (el.classList && (el.classList.contains('efa-cart-live') || el.classList.contains('efa-cart-live-alert'))) continue;
        try { el.inert = true; } catch (e) {}
        el.setAttribute('inert', '');
        el.setAttribute('aria-hidden', 'true');
        el.setAttribute('data-efa-inert', '');
      }
    }
    function clearBackgroundInert() {
      var marked = document.querySelectorAll('[data-efa-inert]');
      Array.prototype.forEach.call(marked, function (el) {
        try { el.inert = false; } catch (e) {}
        el.removeAttribute('inert');
        el.removeAttribute('aria-hidden');
        el.removeAttribute('data-efa-inert');
      });
    }

    /* ---------- Gestion du focus ---------- */
    var lastTrigger = null;
    var trap = null;

    function focusables() {
      return Array.prototype.slice.call(
        cart.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])')
      ).filter(function (el) { return el.offsetParent !== null || getComputedStyle(el).visibility === 'visible'; });
    }

    function onOpen() {
      lastTrigger = document.querySelector('[aria-controls="cart"]') || document.activeElement;
      cart.setAttribute('aria-hidden', 'false');
      // INP : rendre la main au navigateur pour que le tiroir PEIGNE d'abord,
      // puis exécuter le travail lourd (inertie fond + layout + recos) → le clic ne bloque plus le rendu.
      var __efaHeavy = function () {
        setBackgroundInert();
        efaMutating = true;
        try { applyLayout(); } finally { efaMutating = false; }
        loadReco();
      };
      if (window.scheduler && scheduler.postTask) {
        scheduler.postTask(__efaHeavy, { priority: 'user-visible' });
      } else {
        requestAnimationFrame(function () { requestAnimationFrame(__efaHeavy); });
      }
      var tries = 0;
      function focusInto() {
        if (!document.documentElement.classList.contains('m6pn-open')) return;
        if (cart.contains(document.activeElement)) return;
        var target = cart.querySelector('.m6pn-close') || focusables()[0];
        if (target) { try { target.focus({ preventScroll: true }); } catch (e) {} }
      }
      (function tryFocus() {
        if (!document.documentElement.classList.contains('m6pn-open')) return;
        focusInto();
        if (!cart.contains(document.activeElement) && tries++ < 40) { setTimeout(tryFocus, 80); }
      })();
      var onTE = function () { focusInto(); cart.removeEventListener('transitionend', onTE); };
      cart.addEventListener('transitionend', onTE);
      trap = function (e) {
        if (e.key !== 'Tab') return;
        var f = focusables();
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      };
      cart.addEventListener('keydown', trap);
    }

    function onClose() {
      if (pending) applyPending(pending, 'close');   // retrait differe : fermer le tiroir applique le retrait
      cart.setAttribute('aria-hidden', 'true');
      clearBackgroundInert();
      if (trap) { cart.removeEventListener('keydown', trap); trap = null; }
      if (lastTrigger && lastTrigger.focus) { try { lastTrigger.focus({ preventScroll: true }); } catch (e) {} }
    }

    var wasOpen = document.documentElement.classList.contains('m6pn-open');
    new MutationObserver(function () {
      var isOpen = document.documentElement.classList.contains('m6pn-open');
      if (isOpen && !wasOpen) onOpen();
      else if (!isOpen && wasOpen) onClose();
      wasOpen = isOpen;
    }).observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });

    /* ---------- Observer B — re-layout sur tout re-render panier ---------- *
     * Les events shopify:section:* sont éditeur-only : sur le storefront, un re-render
     * (code promo, undo-remove, +/- borné…) ré-injecte une nouvelle .side-cart-wrapper
     * SANS changer data-totalqty. On ré-applique alors layout + recos.
     *
     * GARDE-FOUS ANTI-BOUCLE (obligatoires) :
     *   1) flag self-mutating (efaMutating) : on ignore nos propres écritures DOM.
     *   2) débounce rAF + setTimeout ~150 ms : on coalesce les rafales de mutations.
     *   3) comparaison d'identité du nœud .side-cart-wrapper : on ne réagit que s'il a changé.
     *   4) on ignore toute mutation dont la cible est dans [data-reco] / .efa-cart-xsell
     *      (loadReco et applyLayout écrivent là). */
    var reRenderRaf = null, reRenderTimer = null;
    function scheduleReLayout() {
      /* MutationObserver s'execute avant la peinture : evite tout flash du CTA
         vide lorsque la derniere ligne est encore annulable. */
      syncCartVisualState();
      keepRecoAcrossRender();   // EFA 24/09 : suggestions conservees au re-rendu, avant la peinture
      if (reRenderRaf) return;
      var raf = window.requestAnimationFrame || function (cb) { return setTimeout(cb, 16); };
      reRenderRaf = raf(function () {
        reRenderRaf = null;
        clearTimeout(reRenderTimer);
        reRenderTimer = setTimeout(function () {
          var wrap = cart.querySelector('.side-cart-wrapper');
          // (3) ne réagir que si le wrapper est un NOUVEAU nœud
          if (wrap && wrap === lastWrapper) return;
          lastWrapper = wrap || lastWrapper;
          // ré-affirmer l'état du dialogue si le tiroir est ouvert (un re-render source
          // peut réinjecter aria-hidden=true sans repasser par onOpen)
          if (document.documentElement.classList.contains('m6pn-open')) {
            cart.setAttribute('aria-hidden', 'false');
          }
          efaMutating = true;
          try { applyLayout(); } finally { efaMutating = false; }
          loadReco();
        }, 150);
      });
    }
    new MutationObserver(function (mutations) {
      // (1) ignorer nos propres écritures
      if (efaMutating) return;
      var relevant = false;
      for (var i = 0; i < mutations.length; i++) {
        var t = mutations[i].target;
        // (4) ignorer les mutations issues du cross-sell lui-même
        if (t && t.closest && t.closest('[data-reco],.efa-cart-xsell')) continue;
        if (isUndoMutation(mutations[i])) continue;   // retrait differe : nos propres noeuds
        relevant = true;
        break;
      }
      if (relevant) scheduleReLayout();
    }).observe(cart, { childList: true, subtree: true });

    /* ==========================================================================
       SUPPRESSION ANNULABLE : RETRAIT DIFFERE (EFA 24/09/2026)
       Mesure du 24/09 : le theme (custom-async.js, removeItem) envoie /cart/change
       quantite 0 des le clic, puis remplace tout le tiroir par le rendu serveur
       (handleCartPanel). Pour le dernier article, le tiroir montrait donc le panier
       VIDE pendant la fenetre d'annulation, et « Annuler » re-ajoutait l'article par
       /cart/add.js (article perdu si la ligne porte des proprietes).
       Ici, le clic sur la croix est intercepte AVANT le theme (capture sur window).
       Pendant la fenetre rien ne part au serveur : le tiroir reste le panier reel
       (total, economies, paiement, suggestions) ; la ligne est estompee et son
       selecteur de quantite devient « Annuler ». Le retrait est applique a
       l'expiration, a la fermeture du tiroir, au paiement, a toute navigation depuis
       le tiroir, a une autre suppression, ou au depart de la page (sendBeacon).
       Rendu final par le theme lui-meme (window.ajaxCart.load).
       Annuler = arreter la minuterie : zero requete, aucun faux ajout au panier.
       Perimetre : tiroir #cart hors page /cart (qui garde le flux natif du theme).
       Revert : retirer ce bloc et les lignes marquees « retrait differe ».
       ========================================================================== */
    var EFA_EN = /^en\b/i.test(document.documentElement.getAttribute('lang') || '');
    var TXT = EFA_EN ? {
      close: 'Close cart',
      undo: 'Undo',
      undoName: 'Undo removal of {t}',
      pending: '{t}: removal in progress. You can undo.',
      kept: '{t} stays in your cart.',
      removed: '{t} was removed from your cart.',
      empty: '{t} was removed. Your cart is empty.',
      error: '{t} could not be removed. It is still in your cart.'
    } : {
      close: 'Fermer le panier',
      undo: 'Annuler',
      undoName: 'Annuler le retrait de {t}',
      pending: '{t} : retrait en cours. Vous pouvez annuler.',
      kept: '{t} reste dans votre panier.',
      removed: '{t} a été retiré de votre panier.',
      empty: '{t} a été retiré. Votre panier est vide.',
      error: 'Le retrait de {t} n’a pas pu être enregistré. L’article est toujours dans votre panier.'
    };
    /* Icone « annuler » : fleche en crochet, pointe alignee sur sa hampe, boite du trace
       centree dans le viewBox (x et y de 2.75 a 13.25 sur 16). */
    var UNDO_ICON = '<svg class="efa-undo__icon" viewBox="0 0 16 16" width="14" height="14" aria-hidden="true" focusable="false">' +
      '<path d="M6.25 2.75 2.75 6.25l3.5 3.5M2.75 6.25h7a3.5 3.5 0 0 1 0 7h-1.5" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    var REDUCED = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    var sectionId = cart.getAttribute('data-section-id') || '';
    var pending = null;   // { key, name, delay, remaining, t0, timer, paused, holds, applying, focus, beaconed }
    /* derniere modalite de saisie : la pause au focus ne vaut que pour le clavier */
    var lastInputKeyboard = false;
    window.addEventListener('keydown', function () { lastInputKeyboard = true; }, true);
    window.addEventListener('pointerdown', function () { lastInputKeyboard = false; }, true);

    function fmt(s, t) { return s.replace('{t}', t); }
    function wait(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }
    function drawerOpen() { return document.documentElement.classList.contains('m6pn-open'); }

    function deferredAllowed(link) {
      if (!link || !cart.contains(link) || !link.getAttribute('data-key')) return false;
      var li = link.closest('li');
      if (!li || !li.parentNode || !li.parentNode.classList.contains('l4ca')) return false;
      if (!li.querySelector('.removed')) return false;                         // annulation desactivee dans les reglages : flux natif
      if (document.querySelector('.form-cart, .cart-empty')) return false;     // page /cart : le theme y re-rend aussi la page, flux natif
      return !!(window.fetch && window.Promise && window.ajaxCart && typeof window.ajaxCart.load === 'function');
    }
    function lineFor(key) {
      var links = cart.querySelectorAll('.l4ca > li a.remove-from-cart-link');
      for (var i = 0; i < links.length; i++) {
        if (links[i].getAttribute('data-key') === key) return links[i].closest('li');
      }
      return null;
    }
    function lineName(li) {
      var a = li.querySelector('h2 a');
      var name = a ? a.textContent.replace(/\s+/g, ' ').trim() : '';
      var opt = li.querySelector('section .small.margin-half');
      var o = opt ? opt.textContent.replace(/\s+/g, ' ').trim() : '';
      return o ? name + ', ' + o : name;
    }
    function remainingNow(p) {
      if (!p.delay) return 0;
      return p.paused ? p.remaining : Math.max(0, p.remaining - (Date.now() - p.t0));
    }
    function arm(p) {
      clearTimeout(p.timer);
      p.t0 = Date.now();
      if (p.delay && !p.paused) p.timer = setTimeout(function () { applyPending(p, 'timeout'); }, p.remaining);
    }
    /* Pause tant que la souris est sur « Annuler » ou que le focus CLAVIER y est. */
    function hold(p, reason, on) {
      if (pending !== p || p.applying || !p.delay) return;
      p.holds[reason] = !!on;
      var want = !!(p.holds.hover || p.holds.focus);
      if (want === p.paused) return;
      if (want) { clearTimeout(p.timer); p.remaining = remainingNow(p); p.paused = true; }
      else { p.paused = false; arm(p); }
      var li = lineFor(p.key);
      if (li) li.classList.toggle('efa-pending--paused', p.paused);
    }

    function decorate(li, p, instant) {
      var was = efaMutating;
      efaMutating = true;
      try {
        li.classList.add('efa-pending');
        li.classList.toggle('efa-pending--instant', !!instant);
        li.classList.toggle('efa-pending--paused', !!p.paused);
        var host = li.querySelector('.efa-qty') || li.querySelector(':scope > footer') || li;
        var box = document.createElement('span');
        box.className = 'efa-undo';
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'efa-undo__btn';
        btn.setAttribute('aria-label', fmt(TXT.undoName, p.name));
        btn.innerHTML = UNDO_ICON + '<span class="efa-undo__label" aria-hidden="true"></span>';
        btn.lastChild.textContent = TXT.undo;
        box.appendChild(btn);
        host.appendChild(box);
        if (p.delay) {
          var bar = document.createElement('span');
          bar.className = 'efa-undo__timer';
          bar.setAttribute('aria-hidden', 'true');
          bar.style.animationDuration = p.delay + 'ms';
          bar.style.animationDelay = (remainingNow(p) - p.delay) + 'ms';
          li.appendChild(bar);
        }
        btn.addEventListener('click', function (e) { e.preventDefault(); undo(p); });
        btn.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') hold(p, 'hover', true); });
        btn.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') hold(p, 'hover', false); });
        btn.addEventListener('focus', function () {
          p.focus = true;
          var kb = false;
          try { kb = lastInputKeyboard && btn.matches(':focus-visible'); } catch (x) {}
          hold(p, 'focus', kb);
        });
        btn.addEventListener('blur', function (e) {
          if (e.relatedTarget) p.focus = false;   // focus parti ailleurs (et non noeud remplace par un rendu)
          hold(p, 'focus', false);
        });
        /* le reste de la ligne devient inerte : ni clic, ni tabulation, ni lecture */
        Array.prototype.forEach.call(li.querySelectorAll(':scope > header, :scope > section, :scope > footer > :not(.efa-qty):not(.efa-undo), .efa-qty > :not(.efa-undo)'), function (n) {
          n.setAttribute('inert', '');
          n.setAttribute('data-efa-inert-line', '');
        });
        return btn;
      } finally {
        efaMutating = was;
      }
    }
    function undecorate(li) {
      var was = efaMutating;
      efaMutating = true;
      try {
        Array.prototype.forEach.call(li.querySelectorAll('[data-efa-inert-line]'), function (n) {
          n.removeAttribute('inert');
          n.removeAttribute('data-efa-inert-line');
        });
        Array.prototype.forEach.call(li.querySelectorAll('.efa-undo, .efa-undo__timer'), function (n) { n.parentNode.removeChild(n); });
        li.classList.remove('efa-pending', 'efa-pending--instant', 'efa-pending--paused', 'efa-pending--applying', 'efa-pending--collapse');
        li.style.height = '';
      } finally {
        efaMutating = was;
      }
    }

    function start(link) {
      var li = link.closest('li');
      var d = parseFloat(li.parentNode.getAttribute('data-delay'));
      var p = {
        key: link.getAttribute('data-key'), name: lineName(li),
        delay: (isFinite(d) && d > 0) ? d : 0,   // sans delai regle : pas d'expiration, le retrait part a la fermeture ou a la navigation
        remaining: 0, t0: Date.now(), timer: null, paused: false, holds: {}, applying: null, focus: false, beaconed: false
      };
      p.remaining = p.delay;
      var hadFocus = li.contains(document.activeElement);
      pending = p;
      var btn = decorate(li, p, REDUCED);
      arm(p);
      if (hadFocus) { try { btn.focus({ preventScroll: true }); } catch (x) {} }
      live.textContent = fmt(TXT.pending, p.name);
    }

    function undo(p) {
      if (pending !== p || p.applying) return;
      pending = null;
      clearTimeout(p.timer);
      var li = lineFor(p.key);
      if (!li) return;
      var hadFocus = li.contains(document.activeElement);
      li.classList.add('efa-pending--restore');
      undecorate(li);
      if (hadFocus) {
        var x = li.querySelector('a.remove-from-cart-link');
        if (x) { try { x.focus({ preventScroll: true }); } catch (e) {} }
      }
      setTimeout(function () { li.classList.remove('efa-pending--restore'); }, 260);
      live.textContent = fmt(TXT.kept, p.name);
    }

    function applyPending(p, reason) {
      if (!p) return Promise.resolve(true);
      if (p.applying) return p.applying;
      clearTimeout(p.timer);
      var li = lineFor(p.key);
      if (li) li.classList.add('efa-pending--applying');
      p.applying = fetch(root + 'cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        keepalive: true,   // survit a un depart de page pendant la requete
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: p.key, quantity: 0, sections: sectionId })
      }).then(function (r) {
        return r.json().then(function (j) { if (!r.ok || (j && j.status)) throw j; return j; });
      }).then(function (res) {
        return settle(p, res, reason);
      }, function (err) {
        return fail(p, err, reason);
      });
      return p.applying;
    }

    function settle(p, res, reason) {
      if (pending === p) pending = null;
      if (reason === 'navigate') return true;   // la page part : aucun rendu (le formulaire de paiement doit rester dans le DOM)
      var li = lineFor(p.key);
      var empty = res.item_count === 0;
      var focusHere = !!li && (li.contains(document.activeElement) || (p.focus && document.activeElement === document.body));
      var nextKey = null;
      if (li) {
        var sib = li.nextElementSibling || li.previousElementSibling;
        var sl = sib && sib.querySelector ? sib.querySelector('a.remove-from-cart-link') : null;
        nextKey = sl ? sl.getAttribute('data-key') : null;
      }
      function render() {
        var open = drawerOpen();
        efaSilentCount = true;
        try {
          if (res.sections && res.sections[sectionId]) window.ajaxCart.load(res, open);
          else window.ajaxCart.load(false, open, false, true);
        } catch (e) {
          try { window.ajaxCart.load(false, open, false, true); } catch (e2) {}
        }
        setTimeout(function () { efaSilentCount = false; }, 0);   // apres l'observateur A (microtache)
        syncPending();   // un autre retrait en attente est repose tout de suite, avant le choix du focus
        /* le rendu detruit l'element focalise : on replace le focus dans le tiroir, jamais sur body */
        if (open && (focusHere || !cart.contains(document.activeElement))) {
          var target = null;
          var other = (pending && pending !== p) ? lineFor(pending.key) : null;
          if (other && pending.focus) target = other.querySelector('.efa-undo__btn');
          else if (empty) target = cart.querySelector('.efa-cart-empty__cta');
          else if (nextKey) {
            var nl = lineFor(nextKey);
            target = nl && (nl.querySelector('.efa-undo__btn') || nl.querySelector('a.remove-from-cart-link'));
          }
          if (!target) { target = cart.querySelector('header[data-totalqty]'); if (target) target.setAttribute('tabindex', '-1'); }
          if (target) {
            try { target.focus({ preventScroll: true }); } catch (e3) {}
            /* au clavier, openPanel -> hidePanels du theme renvoie le focus sur l'icone panier 100 ms plus tard
               (custom-async.js, hidePanels) : on le reprend une fois */
            setTimeout(function () {
              if (drawerOpen() && !cart.contains(document.activeElement) && target.isConnected) { try { target.focus({ preventScroll: true }); } catch (e4) {} }
            }, 180);
          }
        }
        var tot = cart.querySelector('.l4tt li.strong');
        live.textContent = empty ? fmt(TXT.empty, p.name)
          : fmt(TXT.removed, p.name) + (tot ? ' ' + tot.textContent.replace(/\s+/g, ' ').trim() : '');
        return true;
      }
      if (!li || !drawerOpen() || REDUCED) return render();
      if (empty) {
        /* dernier article : le tiroir s'efface d'un seul geste, puis le panier vide entre */
        cart.classList.add('efa-cart-exit');
        return wait(200).then(function () {
          cart.classList.remove('efa-cart-exit');
          cart.classList.add('efa-cart-enter');
          var done = render();
          /* la fin de l'entree se compte APRES le rendu, synchrone et long (250 a 380 ms mesures le 24/09) :
             comptee avant, elle coupait l'animation du bloc vide (65 ms visibles sur 240 a 375) */
          var endEnter = function () { cart.classList.remove('efa-cart-enter'); cart.removeEventListener('animationend', onEnter); };
          var onEnter = function (e) { if (e.animationName === 'efa-cart-empty-in') endEnter(); };
          cart.addEventListener('animationend', onEnter);
          setTimeout(endEnter, 1000);
          return done;
        });
      }
      /* il reste des articles : la ligne se replie, les suivantes remontent, puis le theme re-rend */
      li.style.height = li.offsetHeight + 'px';
      void li.offsetHeight;
      li.classList.add('efa-pending--collapse');
      return wait(240).then(render);
    }

    /* Avant de conclure a l'echec, on relit le panier reel : /cart/change.js rend 400 (« Pas d'identifiant ou de
       parametre de ligne valide ») sur une cle ABSENTE quand le panier n'est pas vide (mesure 24/09). La ligne peut
       donc etre deja retiree (autre onglet, page rendue avant un retrait) : ce n'est pas un echec, on termine le retrait. */
    function fail(p, err, reason) {
      return fetch(root + 'cart.js', { credentials: 'same-origin', cache: 'no-store', headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (now) {
          var list = now && now.items;
          var still = !!(list && list.some(function (it) { return it.key === p.key; }));
          if (list && !still) return settle(p, { item_count: now.item_count }, reason);
          return restore(p, err, reason, !!list);
        }, function () { return restore(p, err, reason, false); });
    }
    function restore(p, err, reason, known) {
      if (pending === p) pending = null;
      var li = lineFor(p.key);
      var hadFocus = !!li && li.contains(document.activeElement);
      if (li) undecorate(li);
      if (hadFocus) {
        var x = li.querySelector('a.remove-from-cart-link');
        if (x) { try { x.focus({ preventScroll: true }); } catch (e0) {} }
      }
      var msg = fmt(TXT.error, p.name);
      liveAlert.textContent = msg;
      try { window.dispatchEvent(new CustomEvent('showAlert', { detail: { message: msg, type: 'error' } })); } catch (e) {}
      /* panier relu et ligne presente : rien a resynchroniser ; relecture impossible : on re-rend le panier reel */
      if (!known && reason !== 'navigate') { try { window.ajaxCart.load(false, drawerOpen(), false, true); } catch (e2) {} }
      return false;
    }

    /* Re-rendu du tiroir pendant la fenetre (suggestion ajoutee, quantite d'une autre ligne,
       code promo) : on repose l'etat « en attente » sur la nouvelle ligne AVANT peinture. */
    function syncPending() {
      var p = pending;
      if (!p) return;
      var li = lineFor(p.key);
      if (!li) { if (!p.applying) { clearTimeout(p.timer); pending = null; } return; }
      if (li.classList.contains('efa-pending')) return;
      var btn = decorate(li, p, true);
      if (p.applying) li.classList.add('efa-pending--applying');
      if (p.focus && (document.activeElement === document.body || !cart.contains(document.activeElement))) {
        try { btn.focus({ preventScroll: true }); } catch (x) {}
      }
    }
    function isUndoMutation(m) {
      var nodes = Array.prototype.slice.call(m.addedNodes).concat(Array.prototype.slice.call(m.removedNodes));
      if (!nodes.length) return false;
      for (var k = 0; k < nodes.length; k++) {
        var n = nodes[k];
        if (!(n.nodeType === 1 && (n.classList.contains('efa-undo') || n.classList.contains('efa-undo__timer')))) return false;
      }
      return true;
    }

    function onRemoveIntent(e) {
      var link = e.target && e.target.closest ? e.target.closest('a.remove-from-cart-link') : null;
      if (!deferredAllowed(link)) return;
      e.preventDefault();
      e.stopPropagation();   // capture sur window : le gestionnaire du theme pose sur le lien ne s'execute pas
      var key = link.getAttribute('data-key');
      if (pending && pending.key === key) return;        // double clic sur la meme croix
      if (pending) applyPending(pending, 'next');        // un seul retrait en attente : le precedent s'applique maintenant
      start(link);
    }
    window.addEventListener('click', onRemoveIntent, true);
    window.addEventListener('keydown', function (e) {
      if (e.key !== ' ' && e.key !== 'Spacebar') return;   // role="button" : Espace doit agir comme Entree
      var link = e.target && e.target.closest ? e.target.closest('a.remove-from-cart-link') : null;
      if (deferredAllowed(link)) onRemoveIntent(e);
    }, true);

    /* Navigation depuis le tiroir pendant la fenetre : le retrait part d'abord, puis on navigue. */
    window.addEventListener('click', function (e) {
      var p = pending;
      if (!p || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
      if (!a || !cart.contains(a)) return;
      if (a.matches('.remove-from-cart-link, .m6pn-close, .remove-discount, [data-panel], [data-panel-hide], [data-efa-add]')) return;
      if (a.getAttribute('target') === '_blank' || a.hasAttribute('download')) return;
      var href = a.getAttribute('href') || '';
      if (!href || href.charAt(0) === '#' || /^javascript:/i.test(href) || a.origin !== location.origin) return;
      e.preventDefault();
      e.stopPropagation();
      applyPending(p, 'navigate').then(function (ok) { if (ok !== false) location.assign(a.href); });
    }, true);
    /* Paiement pendant la fenetre : le retrait est enregistre AVANT l'envoi du formulaire. */
    window.addEventListener('submit', function (e) {
      var p = pending;
      var form = e.target;
      if (!p || !form || !form.matches || !form.matches('#cart form.f8vl')) return;
      e.preventDefault();
      e.stopPropagation();
      var submitter = e.submitter || null;
      if (submitter) submitter.setAttribute('aria-busy', 'true');
      applyPending(p, 'navigate').then(function (ok) {
        if (submitter) submitter.removeAttribute('aria-busy');
        if (ok === false) return;
        if (form.requestSubmit) form.requestSubmit(submitter && submitter.form === form ? submitter : null);
        else form.submit();
      });
    }, true);
    /* Depart de la page (retour, lien hors tiroir, fermeture d'onglet) : envoi garanti. */
    window.addEventListener('pagehide', function () {
      var p = pending;
      if (!p || p.applying) return;   // une requete deja partie est en keepalive
      clearTimeout(p.timer);
      var body = new URLSearchParams();
      body.append('id', p.key);
      body.append('quantity', '0');
      var sent = false;
      try { sent = !!(navigator.sendBeacon && navigator.sendBeacon(root + 'cart/change.js', body)); } catch (x) {}
      if (!sent) { try { fetch(root + 'cart/change.js', { method: 'POST', keepalive: true, credentials: 'same-origin', body: body }); } catch (x2) {} }
      p.beaconed = true;
      try { sessionStorage.setItem('efa-undo-carry', JSON.stringify({ key: p.key, t: Date.now() })); } catch (x3) {}
    });
    window.addEventListener('pageshow', function (e) {
      var p = pending;
      if (!e.persisted || !p || !p.beaconed) return;   // retour depuis le cache : le tiroir montrait encore la ligne
      pending = null;
      try { window.ajaxCart.load(false, drawerOpen(), false, true); } catch (x) {}
    });
    /* Page suivante : elle a pu etre rendue AVANT le balisage. Mesure du 24/09 (rechargement pendant la fenetre) :
       GET du document a 2,07 s, balisage a 3,10 s ; 10 s apres, la pastille disait encore 2 et le tiroir montrait
       l'article retire (panier serveur : 1). On re-applique le retrait (400 sans effet s'il est deja fait), on relit
       le panier, puis on re-rend le tiroir et la pastille, ou on recharge la page panier si elle montre encore la ligne. */
    (function () {
      var carry = null;
      try { carry = JSON.parse(sessionStorage.getItem('efa-undo-carry') || 'null'); sessionStorage.removeItem('efa-undo-carry'); } catch (x) { carry = null; }
      if (!carry || !carry.key || !(Date.now() - carry.t < 20000) || !window.fetch) return;
      /* custom-async.js (ajaxCart) peut s'executer APRES la reponse : on re-rend jusqu'a ce que le compteur
         du tiroir egale celui du serveur (au plus 15 s, un rendu toutes les 2 s au plus). */
      function refresh(n, want, called) {
        if (String(curCount()) === String(want) || n > 30) return;
        var now = Date.now();
        if (window.ajaxCart && typeof window.ajaxCart.load === 'function' && (!called || now - called > 2000)) {
          try { window.ajaxCart.load(false, drawerOpen(), false, true); called = now; } catch (e) {}
        }
        setTimeout(function () { refresh(n + 1, want, called); }, 500);
      }
      fetch(root + 'cart/change.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: carry.key, quantity: 0 })
      }).catch(function () {}).then(function () {
        return fetch(root + 'cart.js', { credentials: 'same-origin', cache: 'no-store', headers: { 'Accept': 'application/json' } });
      }).then(function (r) { return r.json(); }).then(function (j) {
        if (!j || typeof j.item_count !== 'number') return;
        var page = document.querySelector('.form-cart');
        if (page) {
          var shown = page.querySelectorAll('[data-key]');
          for (var i = 0; i < shown.length; i++) { if (shown[i].getAttribute('data-key') === carry.key) { location.reload(); return; } }
          return;
        }
        refresh(0, j.item_count, 0);
      }).catch(function () {});
    })();
    /* ======================== fin SUPPRESSION ANNULABLE ======================== */

    /* ---------- Pied collant : fondu au bord haut, seulement quand du contenu passe dessous ----------
     * Mesure du 24/09 : #cart defile (overflow auto) et le pied .sticky-in-panel y colle en bas ;
     * la classe is-sticky du theme n'est jamais posee apres un re-rendu (observateur pose sur l'ancien
     * noeud). On pose donc nous-memes #cart.efa-cart-more tant qu'il reste du contenu sous le pied. */
    var moreRO = window.ResizeObserver ? new ResizeObserver(function () { syncMore(); }) : null;
    var moreNodes = [];
    function syncMore() {
      var more = cart.scrollHeight - cart.clientHeight - cart.scrollTop > 2;
      if (cart.classList.contains('efa-cart-more') !== more) cart.classList.toggle('efa-cart-more', more);
    }
    function watchMore() {
      if (moreRO) {
        moreNodes = moreNodes.filter(function (n) { if (n.isConnected) return true; moreRO.unobserve(n); return false; });
        var box = cart.querySelector(':scope > .side-cart-wrapper') || cart;
        Array.prototype.forEach.call(box.children, function (n) {
          if (moreNodes.indexOf(n) === -1) { moreNodes.push(n); moreRO.observe(n); }
        });
      }
      syncMore();
    }
    cart.addEventListener('scroll', syncMore, { passive: true });
    window.addEventListener('resize', syncMore);

    /* ---------- Cross-sell : ajout 1-clic (délégué) ---------- */
    document.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('[data-efa-add]') : null;
      if (!btn) return;
      e.preventDefault();
      if (btn.getAttribute('aria-busy') === 'true') return;
      var id = btn.getAttribute('data-efa-add');
      var orig = btn.textContent;
      btn.setAttribute('aria-busy', 'true');
      btn.textContent = '…';
      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
      })
        .then(function (r) { if (!r.ok) return r.json().then(function (j) { throw j; }); return r.json(); })
        .then(function () {
          // Rafraîchir le tiroir. Si le hook natif est indisponible, dégradation gracieuse :
          // recharger la page pour refléter l'ajout côté serveur (jamais de tiroir figé).
          if (window.ajaxCart && window.ajaxCart.load) { return window.ajaxCart.load(); }
          window.location.reload();
        })
        .catch(function (err) {
          liveAlert.textContent = (err && err.description) ? err.description : 'Ajout impossible';
        })
        .then(function () {
          // finally : couvre succès ET échec, le bouton n'est jamais laissé figé.
          btn.removeAttribute('aria-busy');
          btn.textContent = orig;
        });
    });

    function syncQuantityControls() {
      Array.prototype.forEach.call(cart.querySelectorAll('.efa-qty'), function (wrap) {
        var input = wrap.querySelector('input[name="updates[]"]');
        var dec = wrap.querySelector('[data-efa-qty="dec"]');
        var inc = wrap.querySelector('[data-efa-qty="inc"]');
        if (!input || !dec || !inc) return;
        var val = parseFloat(input.value);
        var min = parseFloat(input.getAttribute('min')) || 1;
        var max = parseFloat(input.getAttribute('max'));
        var li = wrap.closest('.l4ca > li');
        var remove = li && li.querySelector('a.remove-from-cart-link');
        if (!dec.hasAttribute('data-efa-decrease-label')) dec.setAttribute('data-efa-decrease-label', dec.getAttribute('aria-label') || '');
        dec.disabled = val <= min && val !== 1;
        inc.disabled = isFinite(max) && val >= max;
        dec.setAttribute('aria-label', val === 1 && remove ? remove.getAttribute('aria-label') : dec.getAttribute('data-efa-decrease-label'));
      });
    }

    /* ---------- Steppers quantité +/- (déclenchent la MAJ native du thème) ---------- */
    document.addEventListener('click', function (e) {
      var qb = e.target.closest ? e.target.closest('[data-efa-qty]') : null;
      if (!qb || !qb.closest('#cart')) return;
      e.preventDefault();
      var wrap = qb.closest('.efa-qty');
      if (!wrap) return;
      // Anti-rebond : ignorer les clics tant qu'une MAJ est en cours sur ce stepper.
      if (qb.disabled || wrap.getAttribute('aria-busy') === 'true') return;
      var input = wrap.querySelector('input[name="updates[]"]');
      if (!input || input.disabled) return;
      var step = parseFloat(input.getAttribute('step')) || 1;
      var min = parseFloat(input.getAttribute('min')); if (isNaN(min) || min < 1) min = 1;
      var max = parseFloat(input.getAttribute('max')); if (isNaN(max)) max = Infinity;
      var val = parseFloat(input.value) || min;
      if (qb.getAttribute('data-efa-qty') === 'dec' && val === 1) {
        var line = wrap.closest('.l4ca > li');
        var removeLink = line && line.querySelector('a.remove-from-cart-link');
        if (removeLink) removeLink.click();
        return;
      }
      val += (qb.getAttribute('data-efa-qty') === 'inc' ? step : -step);
      if (val < min) val = min;
      if (val > max) val = max;
      if (String(val) === String(input.value)) return;
      // État « en cours » : retiré au prochain re-render (observer B) ou par sécurité ~600 ms.
      wrap.setAttribute('aria-busy', 'true');
      setTimeout(function () {
        if (wrap && wrap.getAttribute('aria-busy') === 'true') wrap.removeAttribute('aria-busy');
      }, 600);
      input.value = val;
      syncQuantityControls();
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });

    /* ---------- Note / message cadeau (sauvegarde débouncée) ---------- */
    var noteTimer = null;
    document.addEventListener('input', function (e) {
      var ta = e.target;
      if (!ta || !ta.matches || !ta.matches('[data-efa-note]')) return;
      var val = ta.value;
      clearTimeout(noteTimer);
      noteTimer = setTimeout(function () {
        fetch(root + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ note: val })
        }).catch(function () {});
      }, 600);
    });

    /* ---------- Cross-sell : recommandations dynamiques (script intelligent) ---------- */
    var recoAbort = null;
    var recoLastBox = null;   // EFA 24/09 : dernier bloc .efa-cart-xsell[data-reco] peint par loadReco

    /* EFA 24/09 : TROU DES SUGGESTIONS AU RE-RENDU DU TIROIR.
       Mesure : apres /cart/change, window.ajaxCart.load remplace le tiroir par le rendu serveur,
       dont le bloc .efa-cart-xsell[data-reco] arrive hidden et VIDE ; loadReco ne le remplit
       qu'apres rAF + 150 ms + /cart.js + /recommendations (1,7 a 1,8 s a 0 x 0, le pied remonte,
       la note reste dans l'encadre de reassurance jusqu'a applyLayout).
       Ici, dans la microtache du MutationObserver (avant la peinture) : on DEPLACE les cartes deja
       affichees dans le nouveau bloc, on le laisse visible et on applique la mise en page tout de
       suite. loadReco suit sans vider la liste : flush n'ajoute que les pid absents, le rendu final
       reordonne, clone les nouvelles cartes et retire celles qui ne sont plus retenues. */
    function keepRecoAcrossRender() {
      var nb = cart.querySelector('.efa-cart-xsell[data-reco]');
      var old = recoLastBox;
      if (!nb || nb === old) return;
      efaMutating = true;
      try {
        var ol = old && !old.hidden ? old.querySelector('[data-reco-list]') : null;
        var nl = nb.querySelector('[data-reco-list]');
        if (ol && nl && ol.children.length && !nl.children.length) {
          while (ol.firstChild) nl.appendChild(ol.firstChild);
          nb.hidden = false;
          nb.setAttribute('data-seen', '1');   // pas de re-animation d'entree
        }
        applyLayout();   // idempotent : bloc sous les articles, reassurance avant le total, note hors de l'encadre
      } finally {
        efaMutating = false;
      }
      recoLastBox = nb;
    }

    function pickSeed(cartData) {
      var items = cartData && cartData.items;
      if (!items || !items.length) return null;
      var best = items[0];
      for (var i = 1; i < items.length; i++) {
        if ((items[i].final_price || items[i].price || 0) > (best.final_price || best.price || 0)) best = items[i];
      }
      // On retourne l'ITEM seed entier (objet) pour disposer du HANDLE (couche 3, repli collection).
      return best;
    }

    /* ---------- Cascade cross-sell : helpers partagés (scope init, ES5) ---------- *
     * CONTRAT DE CARTE (vérifié sur le markup déployé des sections efa-cart-reco /
     * efa-cart-fallback / efa-cart-promo) :
     *   - data-product-id : identifiant produit (dédoublonnage + exclusion panier).
     *   - data-sale="1"   : la carte est RÉELLEMENT remisée (la section ne pose ce flag
     *                       que si compare_at_price > price : aucune fausse remise).
     *   - ADDABLE 1-clic  : la carte contient un button.efa-cart-xsell__add[data-efa-add].
     *                       Les variantes « Choisir » (<a>) et « Épuisé » (<span>) n'ont PAS
     *                       data-efa-add → on les exclut côté JS. Filtrage addable garanti
     *                       quel que soit l'état des sections (markup actuel OU spec future). */
    function cardIsAddable(li) {
      // Un seul vrai signal d'ajout 1-clic : un <button> portant data-efa-add.
      var b = li.querySelector('button[data-efa-add]');
      return !!(b && b.getAttribute('data-efa-add'));
    }
    function cardIsSale(li) {
      return li.getAttribute('data-sale') === '1';
    }
    function normTitle(li) {
      var nm = li.querySelector('.efa-cart-xsell__name');
      return nm ? nm.textContent.trim().toLowerCase().replace(/\s+/g, ' ') : '';
    }

    function loadReco() {
      var cartEl = document.getElementById('cart');
      if (!cartEl) return;
      var boxes = cartEl.querySelectorAll('[data-reco]');
      if (!boxes.length) return;
      // P1-6 : token de génération. Seule la génération courante a le droit d'écrire,
      // ce qui neutralise une microtask périmée que l'abort réseau n'arrête pas.
      var gen = ++recoGen;
      if (recoAbort) { try { recoAbort.abort(); } catch (e) {} }
      recoAbort = ('AbortController' in window) ? new AbortController() : null;
      var signal = recoAbort ? recoAbort.signal : undefined;
      // Mémoriser le focus avant reconstruction (P2-16).
      var prevActive = document.activeElement;
      var wasCartUpdate = cartUpdatedFlag;
      cartUpdatedFlag = false;

      fetch(root + 'cart.js', { signal: signal }).then(function (r) { return r.json(); }).then(function (cartData) {
        var seed = pickSeed(cartData);
        // seedId = product_id (URL /recommendations/products, inchangé) ; seedHandle = handle (couche 3).
        var seedId = seed ? seed.product_id : null;
        var seedHandle = seed ? (seed.handle || ((seed.url || '').split('?')[0].split('/products/')[1] || '')) : '';
        var inCart = {};
        (cartData.items || []).forEach(function (it) { inCart[it.product_id] = true; });

        Array.prototype.forEach.call(boxes, function (box) {
          var list = box.querySelector('[data-reco-list]');
          if (!seed || !list) { box.hidden = true; return; }
          // CIBLE INTERNE >= 10, indépendante du réglage (le réglage ne fait que plafonner vers le haut).
          var TARGET = Math.max(parseInt(box.getAttribute('data-limit'), 10) || 10, 10);
          var POOL_MAX = 60;          // pool large : on collecte au-delà de TARGET pour composer le quota.
          var promoHandle = box.getAttribute('data-promo-handle') || 'promotions';
          var intents = (box.getAttribute('data-intent') || 'complementary,related').split(',');

          var collected = [];          // <li> ADDABLES acceptés, dans l'ordre d'arrivée (dédup global).
          var seen = {};               // pid -> true
          var seenTitles = {};         // titre normalisé -> true
          var firstPaintDone = false;  // le 1er flush a-t-il déjà peint des cartes ?

          // Absorbe un lot de cartes HTML. Filtre ADDABLE-only, exclut panier + seed + doublons.
          // opts.relaxTitles : relâche le dédoublonnage de titre (2e passe). opts.capAt : plafond.
          function absorb(cards, opts) {
            var cap = opts.capAt;
            for (var i = 0; i < cards.length; i++) {
              if (collected.length >= cap) break;
              var li = cards[i];
              if (!cardIsAddable(li)) continue;            // données réelles : QUE des cartes ajoutables 1-clic.
              var pid = li.getAttribute('data-product-id');
              if (!pid || inCart[pid] || seen[pid] || pid === String(seedId)) continue;
              var tkey = normTitle(li);
              if (!opts.relaxTitles && tkey && seenTitles[tkey]) continue;
              seen[pid] = true;
              if (tkey) seenTitles[tkey] = true;
              collected.push(document.importNode(li, true));
            }
          }

          // Récupère le markup d'une section (Section Rendering API) et renvoie ses cartes <li>.
          // try/catch silencieux : un layer en échec ne doit jamais casser la grille (ex. section promo absente).
          function fetchCards(url) {
            return fetch(url, { signal: signal }).then(function (r) {
              if (!r.ok) return '';
              return r.text();
            }).then(function (html) {
              if (!html) return [];
              var doc = new DOMParser().parseFromString(html, 'text/html');
              return doc.querySelectorAll('.efa-reco-cards > li');
            }).catch(function () { return []; });
          }

          // Tri d'affichage quota-aware : on vise >= 50 % de remises RÉELLES, on complète en
          // plein tarif addable, puis on remet les remises restantes ; remises EN TÊTE (stable).
          function orderForDisplay(items) {
            var total = Math.min(items.length, TARGET);
            var sale = [], full = [];
            for (var i = 0; i < items.length; i++) {
              if (cardIsSale(items[i])) sale.push(items[i]); else full.push(items[i]);
            }
            // On VISE >= 50 % de remises, MAIS on les MELANGE avec le plein tarif (demande Timothee :
            // ne pas grouper toutes les remises d'un cote et le reste de l'autre).
            var needS = Math.min(Math.ceil(total / 2), sale.length);     // remises retenues (>= 50 %)
            var needF = Math.min(total - needS, full.length);            // plein tarif retenu
            if (needS + needF < total) needS = Math.min(sale.length, total - needF); // complete avec des remises
            var selS = sale.slice(0, needS);
            var selF = full.slice(0, needF);
            // INTERLEAVE : on alterne remise / plein tarif pour un melange visuel homogene.
            var out = [];
            var iS = 0, iF = 0;
            while (out.length < total && (iS < selS.length || iF < selF.length)) {
              if (iS < selS.length) out.push(selS[iS++]);
              if (iF < selF.length && out.length < total) out.push(selF[iF++]);
            }
            return out.slice(0, total);
          }

          // Rendu INCRÉMENTAL : 1er flush = paint immédiat (jusqu'à 4+ cartes dès le Layer 1) ;
          // flushes suivants = APPEND des seuls nouveaux pid (pas de vidage global → pas de
          // clignotement / ré-animation des premières cartes). Jamais d'écriture si génération périmée.
          function flush() {
            if (gen !== recoGen) return;
            if (!collected.length) return;
            efaMutating = true;
            try {
              var present = {};
              Array.prototype.forEach.call(list.children, function (n) {
                var p = n.getAttribute('data-product-id');
                if (p) present[p] = true;
              });
              // On n'affiche jamais plus que TARGET pendant les flushes progressifs.
              var shown = list.children.length;
              for (var i = 0; i < collected.length && shown < TARGET; i++) {
                var pid = collected[i].getAttribute('data-product-id');
                if (pid && present[pid]) continue;
                list.appendChild(collected[i].cloneNode(true));
                present[pid] = true;
                shown++;
              }
              if (!firstPaintDone) {
                box.hidden = false;
                box.setAttribute('data-seen', '1'); // P2-27 : ne pas rejouer l'animation aux MAJ suivantes.
                firstPaintDone = true;
              }
              recoLastBox = box;   // EFA 24/09 : ce bloc est desormais celui qu'on conserve au prochain re-rendu
            } finally {
              efaMutating = false;
            }
          }

          // ============================ CASCADE ============================
          // Layer 1 RAPIDE (complementary) → paint des ~4 premières cartes ASAP.
          // Layer 2 (related) → Layer 3 (repli même collection) → Layer 4 (appoint remises : collection Soldes).
          // 2e passe filet (titres relâchés) si toujours sous TARGET. Async non bloquant, tout annulable.
          var primaryIntent = (intents[0] || 'complementary').trim() || 'complementary';
          var recoBase = root + 'recommendations/products?section_id=efa-cart-reco&product_id=' + encodeURIComponent(seedId);

          var chain = fetchCards(recoBase + '&intent=' + encodeURIComponent(primaryIntent) + '&limit=24')
            .then(function (cards) { absorb(cards, { relaxTitles: false, capAt: POOL_MAX }); flush(); });

          // Layer 2 — autres intents (related, etc.).
          for (var ii = 1; ii < intents.length; ii++) {
            (function (intent) {
              intent = (intent || '').trim();
              if (!intent) return;
              chain = chain.then(function () {
                if (collected.length >= TARGET) return;
                return fetchCards(recoBase + '&intent=' + encodeURIComponent(intent) + '&limit=24')
                  .then(function (cards) { absorb(cards, { relaxTitles: false, capAt: POOL_MAX }); flush(); });
              });
            })(intents[ii]);
          }

          // Layer 3 — repli « même collection que l'article seed » (contexte produit).
          chain = chain.then(function () {
            if (collected.length >= TARGET || !seedHandle) return;
            return fetchCards(root + 'products/' + seedHandle + '?section_id=efa-cart-fallback')
              .then(function (cards) { absorb(cards, { relaxTitles: false, capAt: POOL_MAX }); flush(); });
          });

          // Layer 4 — APPOINT REMISES : collection Soldes (cartes toujours remisées + addables, à la source).
          // But : viser NEED_SALE = ceil(min(collected,TARGET)/2) remises, et compléter le total jusqu'à TARGET.
          // Tolérant à l'absence de section efa-cart-promo (fetch en échec → 0 carte, aucune casse).
          chain = chain.then(function () {
            var saleCount = 0;
            for (var c = 0; c < collected.length; c++) { if (cardIsSale(collected[c])) saleCount++; }
            var need = Math.ceil(Math.min(collected.length, TARGET) / 2) - saleCount; // déficit de remises
            var short = TARGET - collected.length;                                    // déficit de total
            if ((need <= 0 && short <= 0) || !promoHandle) return;
            return fetchCards(root + 'collections/' + promoHandle + '?section_id=efa-cart-promo')
              .then(function (cards) { absorb(cards, { relaxTitles: false, capAt: POOL_MAX }); flush(); });
          });

          // 2e PASSE FILET — si toujours sous TARGET, relâcher la dédup de titre sur reco (intents).
          chain = chain.then(function () {
            if (collected.length >= TARGET) return;
            var p2 = Promise.resolve();
            intents.forEach(function (intent) {
              intent = (intent || '').trim();
              if (!intent) return;
              p2 = p2.then(function () {
                if (collected.length >= TARGET) return;
                return fetchCards(recoBase + '&intent=' + encodeURIComponent(intent) + '&limit=24')
                  .then(function (cards) { absorb(cards, { relaxTitles: true, capAt: TARGET }); });
              });
            });
            return p2.then(function () { flush(); });
          });

          // RENDU FINAL — composition quota-aware stable + observabilité, sans recréer les nœuds
          // déjà peints (on RÉORDONNE les <li> existants : pas de ré-animation, zéro clignotement).
          chain.then(function () {
            if (gen !== recoGen) return;
            efaMutating = true;
            try {
              if (!collected.length) {
                box.hidden = true;
                box.removeAttribute('data-sale-ratio');
                return;
              }
              var ordered = orderForDisplay(collected);
              // Index des <li> déjà dans le DOM, par pid, pour réutiliser les nœuds (pas de recréation).
              var byPid = {};
              Array.prototype.forEach.call(list.children, function (n) {
                var p = n.getAttribute('data-product-id');
                if (p) byPid[p] = n;
              });
              var saleShown = 0;
              for (var i = 0; i < ordered.length; i++) {
                var pid = ordered[i].getAttribute('data-product-id');
                var node = byPid[pid];
                if (!node) { node = ordered[i].cloneNode(true); } // carte arrivée au final (2e passe).
                list.appendChild(node);                            // appendChild DÉPLACE si déjà présent.
                if (cardIsSale(node)) saleShown++;
                delete byPid[pid];
              }
              // Retirer les <li> en trop (au-delà de TARGET ou non retenus par la composition).
              Object.keys(byPid).forEach(function (p) {
                var n = byPid[p];
                if (n && n.parentNode === list) list.removeChild(n);
              });
              box.hidden = false;
              box.setAttribute('data-seen', '1');
              recoLastBox = box;   // EFA 24/09
              // Observabilité : ratio de remises réellement affichées / total (QA mode dégradé, § verdict data).
              var totalShown = list.children.length;
              var ratio = totalShown ? (Math.round((saleShown / totalShown) * 100) / 100) : 0;
              box.setAttribute('data-sale-ratio', String(ratio));
            } finally {
              efaMutating = false;
            }
            // P2-16 : annonce + repli de focus, après stabilisation DOM.
            // Annoncer seulement si l'injection n'est pas consécutive à une MAJ panier déjà annoncée.
            if (!wasCartUpdate) {
              live.textContent = 'Suggestions mises à jour';
            }
            // Si le focus est retombé sur body ou hors du tiroir (nœud détruit), le replacer
            // sur une ancre PERSISTANTE qui survit au re-render, jamais sur un nœud reconstruit.
            if (prevActive === document.body || !cartEl.contains(document.activeElement)) {
              var anchor = cartEl.querySelector('header[data-totalqty]');
              if (anchor) {
                anchor.setAttribute('tabindex', '-1');
                try { anchor.focus({ preventScroll: true }); } catch (e) {}
              }
            }
          });
        });
      }).catch(function () {});
    }

    /* ---------- Layout : CTA unique dominant + cross-sell remonté après les articles ---------- */
    function applyLayout() {
      var cartEl = document.getElementById('cart');
      if (!cartEl) return;
      syncCartVisualState();
      // CTA secondaire : libellé clair "Voir le panier" (et non "Passer la commande"),
      // suivi d'une flèche animable au CSS. On structure le contenu en DEUX <span> :
      //   .efa-cart-see__label (texte, lu par les lecteurs d'écran)
      //   .efa-cart-see__arrow (flèche décorative aria-hidden, cible des animations CSS).
      // On ne touche QUE le contenu interne du lien : href, role et tous les attributs de
      // l'<a> sont préservés. Idempotent : on ne réécrit pas si la structure est déjà posée.
      var sec = cartEl.querySelector('.link-btn a.overlay-buy_button');
      if (sec && !sec.querySelector('.efa-cart-see__label')) {
        sec.classList.add('efa-cart-see');
        sec.textContent = '';
        var seeLabel = document.createElement('span');
        seeLabel.className = 'efa-cart-see__label';
        seeLabel.textContent = 'Voir le panier';
        var seeArrow = document.createElement('span');
        seeArrow.className = 'efa-cart-see__arrow';
        seeArrow.setAttribute('aria-hidden', 'true');
        seeArrow.textContent = '→'; // → flèche décorative, animable au CSS
        sec.appendChild(seeLabel);
        sec.appendChild(seeArrow);
      }
      // Cross-sell remonté juste après la liste d'articles (comble le vide, position standard)
      var itemsList = cartEl.querySelector('.l4ca');
      if (itemsList) {
        Array.prototype.forEach.call(cartEl.querySelectorAll('.efa-cart-xsell[data-reco]'), function (box) {
          if (itemsList.nextElementSibling !== box) itemsList.insertAdjacentElement('afterend', box);
        });
      }
      // Réassurance remontée JUSTE avant le Total (confiance au point de décision, best practice CRO).
      // Idempotent : on ne déplace que si la zone n'est pas déjà l'élément précédent de .l4tt.
      var l4tt = cartEl.querySelector('.l4tt');
      var bottomZone = cartEl.querySelector('.efa-cart-zone--bottom');
      if (l4tt && bottomZone && l4tt.previousElementSibling !== bottomZone) {
        l4tt.parentNode.insertBefore(bottomZone, l4tt);
      }
      // EFA — sortir la note « + Ajouter un message » HORS de la bulle de reassurance (demande Timothee).
      var giftNote = bottomZone ? bottomZone.querySelector('.efa-cart-giftnote') : null;
      if (giftNote && giftNote.parentNode === bottomZone) {
        bottomZone.parentNode.insertBefore(giftNote, bottomZone);   // EFA 24/09 : place stable des le 1er appel (avant la reassurance)
      }
    }

    /* éditeur de thème : un re-render de section/bloc doit ré-appliquer layout + recos */
    ['shopify:section:load', 'shopify:section:select', 'shopify:block:select', 'shopify:block:deselect'].forEach(function (ev) {
      document.addEventListener(ev, function () {
        efaMutating = true;
        try { applyLayout(); } finally { efaMutating = false; }
        loadReco();
      });
    });

    /* état initial (si le tiroir est déjà peuplé) */
    efaMutating = true;
    try { applyLayout(); } finally { efaMutating = false; }
    loadReco();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* EFA — retour navigateur (bfcache) : le bouton de paiement restait fige en etat
     "processing/processed" (vert "Redirection vers le paiement...") parce que le <form>
     conservait la classe processing/processed quand la page revient du cache. On la
     retire au retour (event.persisted) pour remettre le bouton dans son etat normal. */
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    Array.prototype.forEach.call(document.querySelectorAll('form.processing, form.processed'), function (f) {
      f.classList.remove('processing', 'processed');
    });
    Array.prototype.forEach.call(document.querySelectorAll('button[name="checkout"]'), function (b) {
      b.disabled = false;
      b.classList.remove('processing', 'processed', 'loading');
    });
  });
})();

/* ============================================================================
   EFA — CARROUSEL A FLECHES pour les rangees de suggestions (.efa-cart-xsell__row).
   Page panier ET tiroir, mobile ET desktop. Scrollbar masquee (CSS) + fleches prev/next
   (pastille noire 80%) CONDITIONNELLES : gauche visible si on peut aller a gauche, droite
   si a droite, aucune si tout tient. Robuste : re-scan sur section:load + ouverture tiroir ;
   MutationObserver pour l'injection asynchrone des cartes. Zero dependance.
   ============================================================================ */
(function () {
  'use strict';
  if (window.__efaRecoCarousel) return;
  window.__efaRecoCarousel = true;

  var ROW = '.efa-cart-xsell__row';
  var CARD = '.efa-cart-xsell__card, li';

  function makeArrow(dir) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'efa-reco-arrow efa-reco-arrow--' + dir + ' efa-reco-arrow--off';
    b.setAttribute('aria-label', dir === 'prev' ? 'Produits precedents' : 'Produits suivants');
    b.tabIndex = -1;
    var d = dir === 'prev' ? 'M15 18l-6-6 6-6' : 'M9 18l6-6-6-6';
    b.innerHTML = '<svg viewBox="0 0 24 24" width="19" height="19" aria-hidden="true" focusable="false"><path d="' + d + '" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    return b;
  }

  function setup(row) {
    if (!row || row.__efaCarousel || !row.parentNode) return;
    row.__efaCarousel = true;

    var wrap = document.createElement('div');
    wrap.className = 'efa-reco-carousel';
    row.parentNode.insertBefore(wrap, row);
    wrap.appendChild(row);

    var prev = makeArrow('prev');
    var next = makeArrow('next');
    wrap.appendChild(prev);
    wrap.appendChild(next);

    function stepPx() {
      var c = row.querySelector(CARD);
      var w = c ? c.getBoundingClientRect().width + 12 : row.clientWidth * 0.85;
      return Math.max(w, row.clientWidth - w);
    }
    prev.addEventListener('click', function () { row.scrollBy({ left: -stepPx(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { row.scrollBy({ left: stepPx(), behavior: 'smooth' }); });

    function update() {
      var max = row.scrollWidth - row.clientWidth;
      var scrollable = max > 2;
      var left = row.scrollLeft;
      prev.classList.toggle('efa-reco-arrow--off', !(scrollable && left > 1));
      next.classList.toggle('efa-reco-arrow--off', !(scrollable && left < max - 1));
    }
    /* Le flush de l'injection ASYNC des cartes (jusqu'a ~6-7s) decale la rangee d'~1 carte (la 1re
       carte part a gauche + la fleche gauche apparait a tort). On ANNULE tout scroll parasite TANT QUE
       l'utilisateur n'a pas navigue lui-meme (wheel/touch/clic fleche) -> la rangee reste au debut.
       AUCUNE limite de temps -> robuste aux flush tardifs (le delai fixe de 3,8s ratait le dernier flush). */
    function reset0() { if (!row.__userScrolled && row.scrollLeft > 1) row.scrollTo({ left: 0, behavior: 'auto' }); }
    function markUser() { row.__userScrolled = true; }
    row.__userScrolled = false;
    row.addEventListener('scroll', function () { reset0(); update(); }, { passive: true });
    row.addEventListener('wheel', markUser, { passive: true });
    row.addEventListener('touchstart', markUser, { passive: true });
    row.addEventListener('pointerdown', markUser, { passive: true });
    prev.addEventListener('click', markUser);
    next.addEventListener('click', markUser);
    window.addEventListener('resize', update);
    if (window.MutationObserver) new MutationObserver(function () { reset0(); update(); }).observe(row, { childList: true });
    row.__efaCarouselUpdate = update;
    reset0(); update();
    [200, 500, 1000, 2000, 3500, 5500, 7500].forEach(function (t) { setTimeout(function () { reset0(); update(); }, t); });
  }

  function scan() {
    var rows = document.querySelectorAll(ROW);
    for (var i = 0; i < rows.length; i++) setup(rows[i]);
  }
  window.efaRecoCarouselScan = scan;

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
  document.addEventListener('shopify:section:load', scan);
  /* ouverture du tiroir (le theme re-rend #cart -> nouvelle rangee) : plusieurs passes de scan */
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('[aria-controls="cart"]')) {
      [300, 700, 1400].forEach(function (t) { setTimeout(scan, t); });
    }
  }, true);
  /* OBSERVER ROBUSTE : le tiroir se re-rend (nouvelle rangee) a des moments variables, apres notre
     fenetre de scan -> jamais wrappee. On observe le DOM (childList) et on rescanne (debounce) des
     qu'une rangee apparait/change. Les toggles de classe des fleches ne declenchent pas (childList only). */
  if (window.MutationObserver) {
    var scanTimer;
    var mo = new MutationObserver(function () {
      clearTimeout(scanTimer);
      scanTimer = setTimeout(scan, 150);
    });
    mo.observe(document.body || document.documentElement, { childList: true, subtree: true });
  }
  /* A l'OUVERTURE du tiroir (classe m6pn-open sur <html>), la rangee reco devient reellement rendue :
     on remet alors son scroll a 0 (le flush de l'injection l'avait decalee d'~1 carte tant que le tiroir
     etait cache/non rendu). Plusieurs passes pour attraper le render + l'anim d'ouverture. */
  if (window.MutationObserver) {
    new MutationObserver(function () {
      if (!document.documentElement.classList.contains('m6pn-open')) return;
      [50, 250, 600, 1100].forEach(function (t) {
        setTimeout(function () {
          var rows = document.querySelectorAll('#cart .efa-cart-xsell__row');
          for (var i = 0; i < rows.length; i++) {
            var r = rows[i];
            if (r.__userScrolled) continue;
            r.scrollLeft = 0;
            if (r.scrollLeft > 1) try { r.scrollTo({ left: 0, behavior: 'auto' }); } catch (e) {}
            if (r.__efaCarouselUpdate) r.__efaCarouselUpdate();
          }
        }, t);
      });
    }).observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
  }
})();
